export default "__VITE_ASSET__C_PdzH21__"